import { FC, SVGProps } from 'react'

interface AddPlusCircleIconProps extends SVGProps<SVGSVGElement> {
  size?: number
  color?: string
  strokeWidth?: number
}

/**
 * 圆形加号图标组件
 * 可自定义大小、颜色、线条粗细和背景透明度
 */
export const AddPlusCircleIcon: FC<AddPlusCircleIconProps> = ({
  size = 24,
  color = 'white',
  strokeWidth = 2,
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* 加号 */}
      <path
        d="M12 6V18M6 12H18"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default AddPlusCircleIcon
